import { Record } from 'immutable';
import { DeliveraMenuEntityInterface } from './interface';

const defaultDeliveraMenuEntityProps: DeliveraMenuEntityInterface = {
    'id': '',
    'type': 'ITEM'
};

export default class DeliveraMenuEntity extends Record(defaultDeliveraMenuEntityProps) {

};